import Vue from 'vue';
import html2canvas from 'html2canvas';
import katex from 'katex';
import 'katex/dist/katex.min.css';

const processFormula = async (formulaEl: HTMLElement) => {
  if (formulaEl.getAttribute('data-math-rendered') === 'true') {
    return;
  }
  formulaEl.setAttribute('data-math-rendered', 'true');
  
  const latex = formulaEl.getAttribute('data-value') || formulaEl.textContent;
  if (!latex) {
    return;
  }

  try {
    const tempDiv = document.createElement('span');
    katex.render(latex, tempDiv, {
      throwOnError: false,
      displayMode: false
    });
    
    // eslint-disable-next-line no-param-reassign
    formulaEl.innerHTML = '';
    formulaEl.appendChild(tempDiv);
    
    const canvas = await html2canvas(formulaEl, {
      backgroundColor: null,
      logging: false
    });
    
    const img = document.createElement('img');
    img.src = canvas.toDataURL('image/png');
    img.className = 'rendered-math-formula';
    img.style.verticalAlign = 'middle';
    img.style.display = 'inline-block';
    img.style.margin = '0 2px';
    img.alt = latex;
    
    if (formulaEl.parentNode) {
      formulaEl.parentNode.replaceChild(img, formulaEl);
    }
  } catch (e) {
    // eslint-disable-next-line no-console
    console.error('Error rendering math formula:', e);
  }
};

const renderFormulas = (el: HTMLElement) => {
  const formulas = el.querySelectorAll('.ql-formula');
  if (!formulas.length) return;

  const formulaElements = Array.from(formulas) as HTMLElement[];
  const promises = formulaElements.map((formulaEl) => processFormula(formulaEl));

  Promise.all(promises).catch((error) => {
    // eslint-disable-next-line no-console
    console.error('Failed to process some formulas:', error);
  });
};

const directive_render_math = {
  inserted(el: HTMLElement) {
    Vue.nextTick(() => {
      renderFormulas(el);
    });
  },
  componentUpdated(el: HTMLElement) {
    Vue.nextTick(() => {
      renderFormulas(el);
    });
  }
};

const directive_scroll = {
  inserted(el: any, binding: any) {
    let idTimer = 0;

    const removeEventListener = (evt: any) => {
      if (!binding.value(el, evt)) {
        clearTimeout(idTimer);
        window.removeEventListener('scroll', removeEventListener, true);
      }
    };

    idTimer = setTimeout(() => {
      window.addEventListener('scroll', removeEventListener, true);
    }, 1000);
  }
};

const directive_click_outside = {
  bind(el: any, binding: any) {
    const { bubble } = binding.modifiers;
    const click_outside_handler = (e: any) => {
      if (bubble || (!el.contains(e.target) && el !== e.target)) {
        binding.value(e);
      }
    };
    document.addEventListener('click', click_outside_handler);
  }
};

Vue.directive('scroll', directive_scroll);
Vue.directive('click-outside', directive_click_outside);
Vue.directive('render-math', directive_render_math);
